
import React from 'react';
import { SERVICES } from '../constants';

const Services: React.FC = () => {
  return (
    <section id="services" className="py-24 bg-white dark:bg-background-dark/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
        <h2 className="text-accent font-bold uppercase tracking-[0.2em] text-xs sm:text-sm mb-4">What We Do</h2>
        <p className="text-3xl sm:text-4xl lg:text-5xl font-black mb-6 text-dark-gray dark:text-white">Our Roofing Specialties</p>
        <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
          From emergency storm repairs to custom tile installations, we provide the highest quality craftsmanship for Florida homeowners.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {SERVICES.map((service, index) => (
          <div 
            key={index} 
            className="group p-8 rounded-2xl bg-background-light dark:bg-gray-800/40 hover:bg-white dark:hover:bg-gray-800 hover:shadow-2xl transition-all duration-500 border border-transparent hover:border-gray-200 dark:hover:border-gray-700 cursor-default"
          >
            <div className="w-12 h-1.5 bg-primary mb-6 rounded-full group-hover:w-full transition-all duration-700"></div>
            <h3 className="text-xl font-bold mb-3 text-dark-gray dark:text-white group-hover:text-primary transition-colors">
              {service.title}
            </h3>
            <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed mb-6">
              {service.description}
            </p>
            <div className="flex items-center gap-2 text-primary text-sm font-bold opacity-0 group-hover:opacity-100 translate-x-[-10px] group-hover:translate-x-0 transition-all">
              <span>Learn More</span>
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
